(function ($, Cobalt, undefined) {
    Cobalt.CPSiteSettings =
    {
        initialize: function () {
            $(document).on("change", ".j-enable-auto-post-merge", function () {
                Cobalt.CPSiteSettings.handleEnableAutoPostMergeChange($(this));
            });
            Cobalt.CPSiteSettings.handleEnableAutoPostMergeChange($(".j-enable-auto-post-merge"));

            var gravatarDefaultField = $("#field-gravatar-default");
            var gravatarCustomField = $("#field-gravatar-custom");
            if (gravatarDefaultField.length > 0 && gravatarCustomField.length > 0) {
                Cobalt.CPSiteSettings.loadExampleGravatarImage(gravatarDefaultField, Cobalt.CPSiteSettings.getGravatarDefaultValue(gravatarDefaultField, gravatarCustomField));

                if (gravatarDefaultField.val() === "custom") {
                    gravatarCustomField.parent().removeClass("hide").show();
                }

                gravatarDefaultField.on("change", function () {
                    if ($(this).val() === "custom") {
                        gravatarCustomField.parent().removeClass("hide").show();
                        Cobalt.CPSiteSettings.loadExampleGravatarImage(gravatarDefaultField, Cobalt.CPSiteSettings.getGravatarDefaultValue(gravatarDefaultField, gravatarCustomField));
                    }
                    else {
                        gravatarCustomField.parent().removeClass("hide").hide();
                        Cobalt.CPSiteSettings.loadExampleGravatarImage($(this), Cobalt.CPSiteSettings.getGravatarDefaultValue(gravatarDefaultField, gravatarCustomField));
                    }
                });

                gravatarCustomField.on("keyup", function () {
                    Cobalt.CPSiteSettings.loadExampleGravatarImage(gravatarDefaultField, $(this).val());
                });
            }
        },
        getGravatarDefaultValue: function(gravatarDefaultField, gravatarCustomField) {
            return gravatarDefaultField.val() === "custom" ? gravatarCustomField.val() : gravatarDefaultField.val();
        },
        loadExampleGravatarImage: function (gravatarDefaultField, defaultValue) {
            var url = "http://www.gravatar.com/avatar/00000000000000000000000000000000?d=" + encodeURIComponent(defaultValue) + "&f=y";
            var parent = gravatarDefaultField.parent();
            if (parent.length > 0) {
                var image = $("<img>").attr("src", url).attr("alt", "Example").attr("title", "Example");
                var imageSpan = $("<span>").addClass("j-image").append(image);
                if (parent.find(".j-image").length > 0) {
                    parent.find(".j-image").replaceWith(imageSpan);
                }
                else {
                    parent.append(imageSpan);
                }
            }
        },
        handleEnableAutoPostMergeChange: function ($enableAutoPostMerge) {
            if ($enableAutoPostMerge.is(":checked")) {
                $(".j-auto-post-merge-timeframe").show();
            } else {
                $(".j-auto-post-merge-timeframe").hide();
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPSiteSettings.js